import {
    Notice,
    PreviewCtaWrap,
    PrimaryButton,
} from './styles';

export type PreviewProduct = {
    id: number;
    title: string;
    date: Date;
    schedule: string;
    surfer: string;
};

/**
 * CTA exibido no lugar de cupom/faturamento/pagamento quando o Checkout é
 * renderizado em modo prévia (operador deslogado). Os itens são mostrados pelo
 * próprio layout do Checkout.
 */
export const PreviewLoginCta = ({ onLogin }: { onLogin: () => void }) => (
    <PreviewCtaWrap>
        <Notice>
            Esta é uma prévia das ondas reservadas. Para efetivar o agendamento,
            faça login na conta titular da sua hospedagem.
        </Notice>
        <PrimaryButton type="button" onClick={onLogin}>
            Fazer login para finalizar
        </PrimaryButton>
    </PreviewCtaWrap>
);
